import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Nombrar la presión",
    opening: localizedGenderNode(
      [
      "Hoy noto la presión de ser perfecto/a.",
      "Solo verla.",
      "Estoy aquí."
    ],
      [
      "Hoy noto la presión de ser perfecto/a.",
      "Solo verla.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración."
    ],
      [
      "Pauso conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Dónde es más fuerte la presión de ser perfecto/a?",
      "¿Qué temo que pase si no es perfecto?",
      "¿Dónde se siente en mi cuerpo?"
    ],
      [
      "¿Dónde es más fuerte la presión de ser perfecto/a?",
      "¿Qué temo que pase si no es perfecto?",
      "¿Dónde se siente en mi cuerpo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "La presión es una experiencia, no una identidad."
    ],
      [
      "La presión es una experiencia, no una identidad."
    ]
    ),
    action: localizedGenderNode(
      "una respiración + \"No tengo que ser perfecto/a\".",
      "una respiración + \"No tengo que ser perfecto/a\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "La voz interna",
    opening: localizedGenderNode(
      [
      "Hoy escucho la voz que pide perfección.",
      "Sin pelearla.",
      "Me quedo conmigo."
    ],
      [
      "Hoy escucho la voz que pide perfección.",
      "Sin pelearla.",
      "Me quedo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro hacia adentro y hacia afuera.",
      "Una respiración."
    ],
      [
      "Respiro hacia adentro y hacia afuera.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué dice la voz cuando no es perfecto?",
      "¿Qué palabras se repiten?",
      "¿Cómo me hace sentir?"
    ],
      [
      "¿Qué dice la voz cuando no es perfecto?",
      "¿Qué palabras se repiten?",
      "¿Cómo me hace sentir?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una voz es una voz, no una verdad absoluta."
    ],
      [
      "Una voz es una voz, no una verdad absoluta."
    ]
    ),
    action: localizedGenderNode(
      "una frase - \"Es una voz, no soy yo\".",
      "una frase - \"Es una voz, no soy yo\"."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "El miedo debajo",
    opening: localizedGenderNode(
      [
      "Hoy toco el miedo debajo de la perfección.",
      "Con suavidad.",
      "Estoy aquí."
    ],
      [
      "Hoy toco el miedo debajo de la perfección.",
      "Con suavidad.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Noto mi pecho.",
      "Una respiración."
    ],
      [
      "Noto mi pecho.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿De qué tengo miedo si no es perfecto?",
      "¿Qué valor intento proteger?",
      "¿Qué necesito escuchar aquí?"
    ],
      [
      "¿De qué tengo miedo si no es perfecto?",
      "¿Qué valor intento proteger?",
      "¿Qué necesito escuchar aquí?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "El miedo pide seguridad, no perfección."
    ],
      [
      "El miedo pide seguridad, no perfección."
    ]
    ),
    action: localizedGenderNode(
      "decir en mi corazón \"Estoy lo bastante seguro/a\" una vez.",
      "decir en mi corazón \"Estoy lo bastante seguro/a\" una vez."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Hecho vs. interpretación",
    opening: localizedGenderNode(
      [
      "Hoy separo lo que pasó de lo que interpreto.",
      "Con suavidad.",
      "Estoy aquí."
    ],
      [
      "Hoy separo lo que pasó de lo que interpreto.",
      "Con suavidad.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro hacia adentro y hacia afuera.",
      "Una respiración."
    ],
      [
      "Respiro hacia adentro y hacia afuera.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuál es el hecho simple aquí?",
      "¿Qué historia salta?",
      "¿Qué posibilidad más suave también podría ser cierta?"
    ],
      [
      "¿Cuál es el hecho simple aquí?",
      "¿Qué historia salta?",
      "¿Qué posibilidad más suave también podría ser cierta?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "La interpretación no es obligatoria."
    ],
      [
      "La interpretación no es obligatoria."
    ]
    ),
    action: localizedGenderNode(
      "una frase interna - \"Esto es interpretación\".",
      "una frase interna - \"Esto es interpretación\"."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "El costo",
    opening: localizedGenderNode(
      [
      "Hoy veo el costo de la perfección.",
      "Sin castigo.",
      "Me quedo conmigo."
    ],
      [
      "Hoy veo el costo de la perfección.",
      "Sin castigo.",
      "Me quedo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Ablando un poco los hombros.",
      "Una respiración."
    ],
      [
      "Ablando un poco los hombros.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué me quita la perfección?",
      "¿Dónde me canso?",
      "¿Qué me gustaría aliviar?"
    ],
      [
      "¿Qué me quita la perfección?",
      "¿Dónde me canso?",
      "¿Qué me gustaría aliviar?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Ver el costo es un paso suave."
    ],
      [
      "Ver el costo es un paso suave."
    ]
    ),
    action: localizedGenderNode(
      "escribir una cosa que alivio hoy.",
      "escribir una cosa que alivio hoy."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Disparadores",
    opening: localizedGenderNode(
      [
      "Hoy noto qué activa la necesidad de ser perfecto/a.",
      "Solo lo noto.",
      "Estoy aquí."
    ],
      [
      "Hoy noto qué activa la necesidad de ser perfecto/a.",
      "Solo lo noto.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Noto mi respiración.",
      "Una respiración."
    ],
      [
      "Noto mi respiración.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuándo se enciende más?",
      "¿Qué situación o persona me activa?",
      "¿Qué necesito en ese momento?"
    ],
      [
      "¿Cuándo se enciende más?",
      "¿Qué situación o persona me activa?",
      "¿Qué necesito en ese momento?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cuando noto un disparador, tengo un pequeño espacio."
    ],
      [
      "Cuando noto un disparador, tengo un pequeño espacio."
    ]
    ),
    action: localizedGenderNode(
      "una mano en el pecho cuando sube.",
      "una mano en el pecho cuando sube."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Un límite suave",
    opening: localizedGenderNode(
      [
      "Hoy pongo un límite suave a la perfección.",
      "No es una guerra.",
      "Estoy aquí."
    ],
      [
      "Hoy pongo un límite suave a la perfección.",
      "No es una guerra.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Siento la espalda apoyada.",
      "Una respiración."
    ],
      [
      "Siento la espalda apoyada.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Dónde puedo bajar un 10%?",
      "¿Qué pasaría si fuera suficientemente bueno?",
      "¿Qué límite pequeño me ayudaría hoy?"
    ],
      [
      "¿Dónde puedo bajar un 10%?",
      "¿Qué pasaría si fuera suficientemente bueno?",
      "¿Qué límite pequeño me ayudaría hoy?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un límite pequeño crea espacio para respirar."
    ],
      [
      "Un límite pequeño crea espacio para respirar."
    ]
    ),
    action: localizedGenderNode(
      "decir \"suficientemente bueno\" una vez.",
      "decir \"suficientemente bueno\" una vez."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Una pequeña compasión",
    opening: localizedGenderNode(
      [
      "Hoy intento hablarme con suavidad.",
      "Aunque sea nuevo.",
      "Estoy aquí."
    ],
      [
      "Hoy intento hablarme con suavidad.",
      "Aunque sea nuevo.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Suavizo la mandíbula.",
      "Una respiración."
    ],
      [
      "Suavizo la mandíbula.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cómo le hablaría a un amigo aquí?",
      "¿Qué frase suave necesito escuchar?",
      "¿Qué cambia en mí cuando la escucho?"
    ],
      [
      "¿Cómo le hablaría a un amigo aquí?",
      "¿Qué frase suave necesito escuchar?",
      "¿Qué cambia en mí cuando la escucho?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una palabra suave es suficiente para empezar."
    ],
      [
      "Una palabra suave es suficiente para empezar."
    ]
    ),
    action: localizedGenderNode(
      "una frase suave para mí.",
      "una frase suave para mí."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Ser suficiente",
    opening: localizedGenderNode(
      [
      "Hoy toco la idea de \"suficiente\".",
      "Sin empujar.",
      "Estoy aquí."
    ],
      [
      "Hoy toco la idea de \"suficiente\".",
      "Sin empujar.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Escucho mi respiración.",
      "Una respiración."
    ],
      [
      "Escucho mi respiración.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué se ve como \"suficiente\" hoy?",
      "¿Cómo se siente si lo dejo ser?",
      "¿Qué gano con eso?"
    ],
      [
      "¿Qué se ve como \"suficiente\" hoy?",
      "¿Cómo se siente si lo dejo ser?",
      "¿Qué gano con eso?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Suficiente es una experiencia nueva que estoy aprendiendo."
    ],
      [
      "Suficiente es una experiencia nueva que estoy aprendiendo."
    ]
    ),
    action: localizedGenderNode(
      "elegir una cosa que sea suficiente.",
      "elegir una cosa que sea suficiente."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Una petición para mí",
    opening: localizedGenderNode(
      [
      "Hoy me doy una petición clara.",
      "No una exigencia.",
      "Me quedo conmigo."
    ],
      [
      "Hoy me doy una petición clara.",
      "No una exigencia.",
      "Me quedo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro lento.",
      "Una respiración."
    ],
      [
      "Respiro lento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuál es mi petición más importante ahora?",
      "¿Cómo decirla en una sola frase?",
      "¿Qué estoy dispuesto/a a darme a cambio?"
    ],
      [
      "¿Cuál es mi petición más importante ahora?",
      "¿Cómo decirla en una sola frase?",
      "¿Qué estoy dispuesto/a a darme a cambio?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una petición puede suavizar el día."
    ],
      [
      "Una petición puede suavizar el día."
    ]
    ),
    action: localizedGenderNode(
      "escribir la petición en una frase corta.",
      "escribir la petición en una frase corta."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Un pequeño cambio",
    opening: localizedGenderNode(
      [
      "Hoy elijo un pequeño cambio dentro del día.",
      "No una revolución.",
      "Estoy aquí."
    ],
      [
      "Hoy elijo un pequeño cambio dentro del día.",
      "No una revolución.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Noto un punto de contacto en mi cuerpo.",
      "Una respiración."
    ],
      [
      "Noto un punto de contacto en mi cuerpo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué pequeño cambio estoy dispuesto/a a probar hoy?",
      "¿Cuándo es más fácil probarlo?",
      "¿Qué me recordará suavemente elegirlo?"
    ],
      [
      "¿Qué pequeño cambio estoy dispuesto/a a probar hoy?",
      "¿Cuándo es más fácil probarlo?",
      "¿Qué me recordará suavemente elegirlo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un pequeño cambio es un movimiento suave."
    ],
      [
      "Un pequeño cambio es un movimiento suave."
    ]
    ),
    action: localizedGenderNode(
      "elegir un momento para probarlo.",
      "elegir un momento para probarlo."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Ser humano/a",
    opening: localizedGenderNode(
      [
      "Hoy doy espacio a ser humano/a.",
      "Sin descartarlo.",
      "Estoy aquí."
    ],
      [
      "Hoy doy espacio a ser humano/a.",
      "Sin descartarlo.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración."
    ],
      [
      "Pauso conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué pasaría si me permito ser humano/a?",
      "¿Qué liberaría en mí?",
      "¿Qué suavidad puedo darme?"
    ],
      [
      "¿Qué pasaría si me permito ser humano/a?",
      "¿Qué liberaría en mí?",
      "¿Qué suavidad puedo darme?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Ser humano/a no es un fracaso."
    ],
      [
      "Ser humano/a no es un fracaso."
    ]
    ),
    action: localizedGenderNode(
      "una frase de permiso para mí.",
      "una frase de permiso para mí."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Una pequeña práctica",
    opening: localizedGenderNode(
      [
      "Hoy elijo una práctica pequeña que suaviza la perfección.",
      "Simple.",
      "Estoy aquí."
    ],
      [
      "Hoy elijo una práctica pequeña que suaviza la perfección.",
      "Simple.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Siento mi forma de sentarme.",
      "Una respiración."
    ],
      [
      "Siento mi forma de sentarme.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué práctica pequeña podría ayudarme hoy?",
      "¿Cuándo en el día la hago?",
      "¿Qué me recordará suavemente?"
    ],
      [
      "¿Qué práctica pequeña podría ayudarme hoy?",
      "¿Cuándo en el día la hago?",
      "¿Qué me recordará suavemente?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una práctica pequeña crea un cambio suave."
    ],
      [
      "Una práctica pequeña crea un cambio suave."
    ]
    ),
    action: localizedGenderNode(
      "elegir un momento para la práctica.",
      "elegir un momento para la práctica."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Cierre suave",
    opening: localizedGenderNode(
      [
      "Hoy cierro el viaje con suavidad.",
      "Sin forzar un final perfecto.",
      "Estoy aquí."
    ],
      [
      "Hoy cierro el viaje con suavidad.",
      "Sin forzar un final perfecto.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración."
    ],
      [
      "Pauso conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué aprendí sobre mi perfección?",
      "¿Cuál es la señal temprana de que vuelvo a la presión?",
      "Frase de regreso para el momento antes - ¿qué me digo?"
    ],
      [
      "¿Qué aprendí sobre mi perfección?",
      "¿Cuál es la señal temprana de que vuelvo a la presión?",
      "Frase de regreso para el momento antes - ¿qué me digo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Puedo ser preciso/a sin ser perfecto/a."
    ],
      [
      "Puedo ser preciso/a sin ser perfecto/a."
    ]
    ),
    action: localizedGenderNode(
      "una respiración antes de responder.",
      "una respiración antes de responder."
    ),
  },
].map(buildNormalizedDay);

export const needToBePerfectInEverythingBlueprintEs = buildNormalizedPilotBlueprint({
  id: "need_to_be_perfect_in_everything_14d",
  version: "tri_locale_emit_es_v1",
  durationDays: 14,
  problemKey: "need_to_be_perfect_in_everything",
  category: "self_worth",
  journeyName: {
    he: "פרפקציוניזם (יכול להיות מושלם בהכל)",
    en: "Need to be perfect in everything",
    es: "Necesidad de ser perfecto/a en todo",
  },
  days,
});

export default needToBePerfectInEverythingBlueprintEs;
